import { Polygon } from "@designboticteam/workspace-3d";
import type { ZoneStyleByType } from "./constants";
import type { ZoneType } from "./types";

class Zone extends Polygon {
	private zoneType: ZoneType;
	private readonly zoneStyleByType: ZoneStyleByType;

	constructor({ zoneType, zoneStyleByType }: { zoneType: ZoneType; zoneStyleByType: ZoneStyleByType }) {
		const style = zoneStyleByType[zoneType];
		super({
			label: style.label,
			labelColor: style.color,
			lineColor: style.color,
			fillColor: style.color,
			vertexHandlesColor: style.color,
			vertexHandlesHighlightColor: style.vertexHandleHighlightColor,
			highlightedEdgeColor: style.highlightedEdgeColor,
			selectedEdgeColor: style.selectedEdgeColor,
		});
		this.zoneType = zoneType;
		this.zoneStyleByType = zoneStyleByType;
		this.applyPolygonOffset();
	}

	public getZoneType(): ZoneType {
		return this.zoneType;
	}

	public setZoneType({ zoneType }: { zoneType: ZoneType }): void {
		if (this.zoneType === zoneType) {
			return;
		}

		this.zoneType = zoneType;

		const style = this.zoneStyleByType[zoneType];
		this.setLineColor(style.color);
		this.setFillColor(style.color);
		this.setLabel({ content: style.label, color: style.color });
		this.setVertexHandlesColors({ color: style.color, highlightColor: style.vertexHandleHighlightColor });
		this.setEdgeColors({ highlightedColor: style.highlightedEdgeColor, selectedColor: style.selectedEdgeColor });
		this.applyPolygonOffset();
	}

	/**
	 * Depth-fighting control for overlapping zone fills, read back by RaycastService to break ties
	 * between them. Nothing to do with the geometric offset — that is inherited from Polygon.
	 */
	private applyPolygonOffset(): void {
		const style = this.zoneStyleByType[this.zoneType];
		this.fill.material.polygonOffset = true;
		this.fill.material.polygonOffsetFactor = 1;
		this.fill.material.polygonOffsetUnits = style.offsetY;
		this.fill.material.needsUpdate = true;
	}
}

export { Zone };
